// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skip-button{text-align:right}.skip-button__tooltip-wrapper{text-align:left;display:inline-block}.skip-button__button{font-weight:700}.skip-button--disabled .skip-button__button{opacity:.25}", ""]);
// Exports
module.exports = exports;
